const diashabiles = {
  GetDiasHabiles: 'DiasHabiles/GetDiasHabiles'
}

export default diashabiles;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/diashabiles/funcion/diashabiles.js
// module id = null
// module chunks = 